export const SAVE = '@menu/SIGN_OUT';
export const UPDATE = '@menu/UPDATE';
export const REMOVE = '@menu/REMOVE';